import './css/platforms.css'

import { Panel } from 'primereact/panel'

import {Worldmap, Partners} from '../localfiles/local-platforms'

import { Annotation, ComposableMap, Geographies, Geography } from 'react-simple-maps'
import worldMap from './aboutus/countries-110m.json'
// import { map } from 'jquery'

import React, { useState, useEffect } from 'react'
import Parse from 'html-react-parser'
import useMobileCheck from '../localfiles/mobile-check'

// import Mindmap from './platforms/mindmap'

const Platforms = () => {
        const [active, setActive] = useState('')
        const handlePopup = (e) =>{
            const key = e.currentTarget.getAttribute('data-key')
            setActive(prevActive => prevActive === key ? '' : key)
        }
        
        const geoUrl = worldMap
        const defaultColor = "#b0bec5"
        const CountryCode = {
            'Thailand': `#00b55b`,
            'Laos': '#00b55b',
            'France': '#00b55b'
        }

        const { mobile } = useMobileCheck()

        const [expandedPanel_th, setExpandedPanel_th] = useState(null);
        const [expandedPanel_laos, setExpandedPanel_laos] = useState(null);
        const [expandedPanel_fr, setExpandedPanel_fr] = useState(null);

        const handlePanelToggle_th = (index_th) => {
        setExpandedPanel_th(expandedPanel_th === index_th ? null : index_th);
        };
        const handlePanelToggle_laos = (index_laos) => {
        setExpandedPanel_laos(expandedPanel_laos === index_laos ? null : index_laos);
        };
        const handlePanelToggle_fr = (index_fr) => {
        setExpandedPanel_fr(expandedPanel_fr === index_fr ? null : index_fr);
        };

    return (
        <div className='platforms'>
            <div className="people-modal" style={{display: active? 'block' : 'none'}} onClick={handlePopup}></div>
            <div className="cover">
                <div className="cover-bg"></div>
                <div className="cover-text flyIn">
                    <h1>PLATFORMS</h1>
                </div>
            </div>

            {/* <div className="mindmapping">
                <Mindmap/>
            </div> */}

            {/* World Map */}
            <div className="partners">
                <h1>Partners</h1>
                <div className="worldmap">
                    {Worldmap.map((partner) => (
                        <div className={`containers`} data-key={partner.id} style={{left:`${partner.x}vw`, top: `${partner.y}vw`, display: mobile ? "none" : "block"}}>
                            <div className="head">{partner.name}</div>
                            <div className="logo">
                                {Array.isArray(partner.logo) ? (
                                    partner.logo.map((logo) => (
                                        <a href={logo.href} key={logo.id} target='_blank' rel='noreferrer'>
                                            <img src={logo.src2 ? logo.src2 : logo.src} alt={logo.id} />
                                        </a>
                                    ))
                                ) : (
                                    <p>No partners available</p>
                                )}
                            </div>
                        </div>
                    ))}
                <ComposableMap>
                        <Geographies geography={geoUrl}>
                            {({ geographies }) =>
                            geographies.map((geo) => {
                                const countryName = geo.properties.name
                                const cursorMap = CountryCode[countryName] ? "pointer" : 'context-menu'
                                return (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    style={{
                                        default:{
                                            fill :CountryCode[countryName] || defaultColor,
                                            stroke: "#FFFFFF",
                                            strokeWidth: .1,
                                        },
                                        hover:{
                                            fill: CountryCode[countryName] ? "#006533" : defaultColor,
                                            cursor: cursorMap
                                        },
                                        pressed:{
                                            fill: CountryCode[countryName] ? "#006533" : defaultColor,
                                        }
                                    }}
                                />
                                );
                            })
                            }
                        </Geographies>
                        {/* france */}
                        <Annotation
                            subject={[2.3522, 48.8566]}
                            dx={-90}
                            dy={-30}
                            connectorProps={{
                            stroke: "#006533",
                            strokeWidth: mobile ? 0 : 1,
                            strokeLinecap: "round"
                            }}
                        ></Annotation>
                        {/* laos */}
                        <Annotation
                            subject={[102,20]}
                            dx={-50}
                            dy={-90}
                            connectorProps={{
                            stroke: "#006533",
                            strokeWidth: mobile ? 0 : 1,
                            strokeLinecap: "round"
                            }}
                        ></Annotation>
                        {/* thailand */}
                         <Annotation
                            subject={[70,0]}
                            dx={80}
                            dy={-55}
                            connectorProps={{
                            stroke: "#006533",
                            strokeWidth: mobile ? 0 : 1,
                            strokeLinecap: "round"
                            }}
                        ></Annotation>
                </ComposableMap>
                </div>
            </div>
                <hr />


            <div className="partners-text">
                <h2>Thailand</h2>
                <div className="th">
                    <div className="containers">
                        {Partners
                        .filter(partner => partner.country === "Thailand")
                        .map((partner, index_th) => (
                            <Panel 
                            key={partner.name} 
                            header={
                                <a href={partner.href} target='blank' rel='noreferrer'>
                                    <div className='item'>
                                            <div className="logo">
                                                <img src={partner.imgSrc} alt={partner.name} />
                                            </div>
                                            <div className="text" style={{display: partner.name ? "block" : "none"}}>
                                                <div className="head">
                                                    <h3>{partner.name}, ({partner.country})</h3>
                                                </div>
                                            </div>
                                    </div>
                                </a>
                            } 
                            toggleable = {partner.describe ? true : false}
                            collapsed={expandedPanel_th !== index_th}
                            onToggle={() => handlePanelToggle_th(index_th)}
                            >
                                <div className="text">
                                    <p>{Parse(partner.describe)}</p>
                                </div>
                            </Panel>
                        ))}
                    </div>
                </div>
                <hr />

                <h2>Laos</h2>
                <div className="laos">
                    <div className="containers">
                    {Partners
                        .filter(partner => partner.country === "Laos")
                        .map((partner, index_laos) => (
                            <Panel 
                            key={partner.name} 
                            header={
                                <a href={partner.href} target='blank' rel='noreferrer'>
                                    <div className='item'>
                                            <div className="logo">
                                                <img src={partner.imgSrc} alt={partner.name} />
                                            </div>
                                            <div className="text">
                                                <div className="head">
                                                    <h3>{partner.name}, ({partner.country})</h3>
                                                </div>
                                            </div>
                                    </div>
                                </a>
                            } 
                            toggleable = {partner.describe ? true : false}
                            collapsed={expandedPanel_laos !== index_laos}
                            onToggle={() => handlePanelToggle_laos(index_laos)}
                            >
                                <div className="text">
                                    <p>{Parse(partner.describe)}</p>
                                </div>
                            </Panel>
                        ))}
                    </div>
                </div>
                <hr />

                <h2>France</h2>
                <div className="fr">
                    <div className="containers">
                    {Partners
                        .filter(partner => partner.country === "France")
                        .map((partner, index_fr) => (
                            <Panel 
                            key={partner.name} 
                            header={
                                <a href={partner.href} target='blank' rel='noreferrer'>
                                    <div className='item'>
                                            <div className="logo">
                                                <img src={partner.imgSrc} alt={partner.name} />
                                            </div>
                                            <div className="text">
                                                <div className="head">
                                                    <h3>{partner.name}, ({partner.country})</h3>
                                                </div>
                                            </div>
                                    </div>
                                </a>
                            } 
                            toggleable = {partner.describe ? true : false}
                            collapsed={expandedPanel_fr !== index_fr}
                            onToggle={() => handlePanelToggle_fr(index_fr)}
                            >
                                <div className="text">
                                    <p>{Parse(partner.describe)}</p>
                                </div>
                            </Panel>
                        ))}
                    </div>
                </div>
                <hr />
            </div>
        </div>
            )
        }

export default Platforms